import { mixpanel } from '../../mixpanel';
import { Provider } from './types';
import { flattenEvent } from './utils';

export default {
  id: 'mixpanel',
  emit: (event) => {
    const name = [event.flow, event.object, event.name, event.action]
      .filter(Boolean)
      .join(' ');

    mixpanel((m) =>
      m.track(name, flattenEvent(event, { pattern: /_/g, replacement: ' ' })),
    );
  },
} as Provider;
